module.exports = __webpack_public_path__ + "static/media/car-yellow-only.f9ca62f6.svg";